<template>
  <div class="container">
    <!--进行板块划分-->
    <div class="block">
      <div class="title-wrap">
        <div class="title-wrap-image">
          <img class="avator" :src="membersrc" />
        </div>
      </div>
      <div class="content-inner-wrap">
        <div class="member-info" :member-data="detailData">
          <!--        <img class="avator" :src="detailsrc">   -->
          <!--    <img class="avator"  src="@/assets/images/img_no_table.png">-->
          <div class="info">
            <h2>{{ memberName || 0 }}</h2>
            <p>{{ memberType | memberTypeJudge }}</p>
            <p>加入时间：{{ inTime || 0 }}</p>
            <p>作品数量：{{ productCount || 0 }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">数据总览</div>
      </div>
      <div class="data-view">
        <div
          class="card-wrap"
          v-for="(item, index) in viewData"
          :key="index"
          :item="item"
        >
          <p class="card-title">{{ item.title }}</p>
          <p class="card-value">
            {{ item.value | regroupWan
            }}<span class="card-value-unit" v-if="item.value >= 10000">万</span>
          </p>
          <p class="card-content">
            <span style="margin-right: 8px">昨日</span
            >{{ item.yesterday | regroupWan
            }}<span class="card-value-unit" v-if="item.yesterday >= 10000">
              万
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">作品数据明细</div>
        <div class="title-desc">所选时间范围内有产生数据的作品详情</div>
      </div>
      <div class="content-inner-wrap">
        <div class="data-filter">
          <!--  <span class="mgr25">选择日期</span>  -->
          <date-selector
            v-model="productDate"
            @change="productDateChangeFn"
            :queryBtnClick="handlePDateBtnClicked"
          ></date-selector>
        </div>
        <div class="data-table" v-if="productData.length">
          <my-table
            :tableData="productData"
            :tableField="productColData"
          ></my-table>
          <van-loading
            class="img-loading"
            type="spinner"
            color="#fd9b21"
            size="24px"
            v-show="productDataLoading"
          />
        </div>
        <NoData v-else></NoData>
        <div class="data-filter-page">
          <van-pagination
            class="pagination"
            v-model="productPagination.page"
            :total-items="productPagination.total"
            :page-count="totalPageNum"
            :show-page-size="5"
            force-ellipses
            @change="pDPaginationChange"
            v-if="totalPageNum > 1"
          >
            <template #prev-text>
              <van-icon name="arrow-left" class="arrow-left" />
            </template>
            <template #next-text>
              <van-icon name="arrow" />
            </template>
            <template #page="{ text }">{{ text }}</template>
          </van-pagination>
        </div>
      </div>
    </div>

    <div class="block">
      <div class="title-wrap">
        <div class="title-name">作品收益明细</div>
        <div class="title-desc">所选时间内作品产生的收入</div>
      </div>
      <div class="content-inner-wrap">
        <div class="data-filter">
          <!--     <span class="mgr25">选择日期</span>  -->
          <date-selector
            v-model="InProductDate"
            @change="productIDateChangeFn"
            :queryBtnClick="handlePIDateBtnClicked"
          ></date-selector>
        </div>
        <div class="data-table" v-if="InproductData.length">
          <my-table
            :tableData="InproductData"
            :tableField="InproductColData"
          ></my-table>
          <van-loading
            class="img-loading"
            type="spinner"
            color="#fd9b21"
            size="24px"
            v-show="productDataLoading"
          />
        </div>
        <NoData v-else></NoData>
        <div class="data-filter-page">
          <van-pagination
            class="pagination"
            v-model="InProductPagniation.page"
            :total-items="InProductPagniation.total"
            :page-count="totalPage"
            :show-page-size="5"
            force-ellipses
            @change="IDPaginationChange"
            v-if="totalPage > 1"
          >
            <template #prev-text>
              <van-icon name="arrow-left" class="arrow-left" />
            </template>
            <template #next-text>
              <van-icon name="arrow" />
            </template>
            <template #page="{ text }">{{ text }}</template>
          </van-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 24 * 60 * 60 * 1000;
import {
  getProductDetailData,
  getProductDeatilIncome,
  getStudioMemBaseinfo,
  getStudioMembersOverviewData,
} from '@/api/studio';
import DateSelector from '../../../components/DateSelector.vue';
import MyTable from '../../../components/MyTable.vue';
import NoData from '@/components/NoData.vue';
import { _regroupWan } from '@/utils/index';
export default {
  components: {
    DateSelector,
    MyTable,
    NoData,
  },
  computed: {
    totalPage() {
      return Math.ceil(
        this.InProductPagniation.total / this.InProductPagniation.page_size,
      );
    },
    totalPageNum() {
      return Math.ceil(
        this.productPagination.total / this.productPagination.page_size,
      );
    },
  },
  data() {
    return {
      detailData: [],
      viewData: [],
      membersrc: '',
      memberName: '',
      memberType: this.$route.params.memberType,
      productCount: '',
      inTime: '',
      productDate: '',
      InProductDate: '',
      productDataCount: 0,
      InproductDataCount: 0,
      productData: [],
      InproductData: [],
      lastProductDate: [],
      lastInProductDate: [],
      productDataLoading: false,
      InproductDataLoading: false,
      productPagination: {
        page_size: 5,
        page: 1,
        total: 0,
      },
      InProductPagniation: {
        page_size: 5,
        page: 1,
        total: 0,
      },
      pickerOptions: {
        //判断
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcurts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近3个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      productColData: [
        {
          label: '作品名称',
          prop: 'product_name',
        },
        {
          label: '',
          prop: '',
        },
        /* {
          label:"地图id",
          prop:"map_id",
        },*/
        {
          label: '上传日期',
          prop: 'map_create_time',
        },
        {
          label: '今日下载(预估)',
          prop: 'today_download',
        },
        {
          label: '昨日下载数',
          prop: 'yesterday_download_count',
        },
        {
          label: '总下载数',
          prop: 'download',
        },
        {
          label: '游戏次数',
          prop: 'play_count',
        },
        {
          label: '游戏时长',
          prop: 'play_time',
        },
      ],
      InproductColData: [
        {
          label: '作品名称',
          prop: 'product_name',
        },
        {
          label: '',
          prop: '',
        },
        /* {
          label:"地图id",
          prop:"map_id",
        },*/
        {
          label: '上传日期',
          prop: 'date',
        },
        {
          label: '昨日广告播放数',
          prop: 'yesterday_ad_count',
        },
        {
          label: '广告播放数',
          prop: 'ad_count',
        },
        {
          label: '累计广告收益',
          prop: 'ad_income',
        },
        {
          label: '累计迷你豆',
          prop: 'minibean',
        },
        {
          label: '累计迷你点',
          prop: 'minipoint',
        },
        {
          label: '累计贡献点',
          prop: 'contribution',
        },
      ],
    };
  },
  filters: {
    regroupWan(num, toFixed) {
      return _regroupWan(num, toFixed);
    },
    memberTypeJudge(memberType) {
      return memberType == 1 ? '室长' : '签约成员';
    },
  },
  mounted() {
    this.getProductData();
    //初始化个人信息
    this.getMemberBaseinfo();
    //初始化表达数据
    this.getProductInData();
    this.getStudioMembersData();
    this.viewData = [
      {
        title: '本月广告展示',
        value: 0,
        yesterday: 0,
      },
      {
        title: '本月贡献点',
        value: 0,
        yesterday: 0,
      },
      {
        title: '本月迷你豆',
        value: 0,
        yesterday: 0,
      },
      {
        title: '本月地图下载',
        value: 0,
        yesterday: 0,
      },
    ];
  },
  created() {
    //const currTime=Date.now();
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.productDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
    this.InProductDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
  },
  methods: {
    productDateChangeFn() {
      window.__time__ = this.productDate[0];
    },
    productIDateChangeFn() {
      window.__time__ = this.productDate[0];
    },
    handlePDateBtnClicked() {
      //this.getProductData();
      //   if(this.lastProductDate[0]===this.productDate[0]&&this.lastProductDate[1]===this.productDate[1])return
      this.getProductData();
    },
    handlePIDateBtnClicked() {
      //  if(this.lastInProductDate[0]===this.InProductDate[0]&&this.lastInProductDate[1]===this.InProductDate[1])return
      this.getProductInData();
    },
    pDPaginationChange(currPage) {
      (this.productPagination.page = currPage), this.getProductData();
    },
    IDPaginationChange(currPage) {
      (this.InProductPagniation.page = currPage), this.getProductInData();
    },
    //获取作品详情表
    async getProductData() {
      this.productDataLoading = true;
      this.lastProductDate = this.productDate;
      const res = await getProductDetailData(
        Object.assign(
          {
            page_size: this.productPagination.page_size,
            page: this.productPagination.page,
          },
          {
            start_time: parseInt(this.productDate[0] / 1000, 10),
            end_time: parseInt((this.productDate[1] + ONE_DAY_TIME) / 1000, 10),
            json: 1,
            member_id: this.$route.params.member_id,
          },
        ),
      );
      this.productDataLoading = false;
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.productData = list.map(item => {
            item.play_time = Number(item.play_time).toFixed(2);
            return item;
          });
        }
        this.productPagination.total = parseInt(res.data.total_count, 10);
      }
    },
    //获取作品收入
    async getProductInData() {
      this.InproductDataLoading = true;
      this.lastInProductDate = this.InProductDate;
      const res = await getProductDeatilIncome(
        Object.assign(
          {
            page_size: this.InProductPagniation.page_size,
            page: this.InProductPagniation.page,
          },
          {
            start_time: parseInt(this.InProductDate[0] / 1000, 10),
            end_time: parseInt(
              (this.InProductDate[1] + ONE_DAY_TIME) / 1000,
              10,
            ),
            member_uin: this.$route.params.member_id,
          },
        ),
      );
      this.InproductDataLoading = false;
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.InproductData = list.map(item => {
            item.ad_income = Number(item.ad_income).toFixed(3);
            item.contribution = Number(item.contribution).toFixed(3);
            return item;
          });
        }
        this.InProductPagniation.total = parseInt(res.data.total_count, 10);
      }
    },
    //获取成员个人信息
    async getMemberBaseinfo() {
      let data = {
        member_id: this.$route.params.member_id,
        json: 1,
      };
      const res = await getStudioMemBaseinfo(data);
      this.memberName = res.data.name;
      this.inTime = res.data.join_time;
      this.productCount = res.data.map_count;
      this.membersrc = res.data.avatar_url;
    },
    //获取个人成员数据总览
    async getStudioMembersData() {
      let data = { member_uin: this.$route.params.member_id };
      const res = await getStudioMembersOverviewData(data);
      this.OverviewData = res.data;
      this.viewData = [
        {
          title: '本月广告展示',
          value: this.OverviewData.month_ad_count,
          yesterday: this.OverviewData.yesterday_ad_count,
        },
        {
          title: '本月贡献点',
          value: this.OverviewData.month_contribution,
          yesterday: this.OverviewData.yesterday_contribution,
        },
        {
          title: '本月迷你豆',
          value: this.OverviewData.month_minibean,
          yesterday: this.OverviewData.yesterday_minibean,
        },
        {
          title: '本月地图下载',
          value: this.OverviewData.month_down,
          yesterday: this.OverviewData.yesterday_down,
        },
      ];
      console.log(this.viewData);
    },
  },
};
</script>
<style
  src="../../../assets/styles/introduce-common.less"
  lang="less"
  scoped
></style>
<style lang="less" scoped>
.title-wrap-image {
  display: flex;
  justify-content: center;
  align-items: center;
  .avator {
    width: 120px;
    height: 120px;
    //margin-right: 20px;
    border-radius: 8px;
    border: 1px solid #f565a5;
  }
}
.title-name {
  font-size: 36px;
  font-weight: 600;
  color: #262626;
  line-height: 52px;
}
.title-name-content {
  text-align: center;
  font-size: 40px;
  font-weight: 600;
  color: #3d3c3c;
}
.member-info {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: Helvetica;
  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    h2 {
      font-size: 32px;
      line-height: 38px;
      margin-bottom: 28px;
      color: #000000;
      text-align: center;
    }
    p {
      font-size: 28px;
      line-height: 34px;
      margin-bottom: 22px;
      color: #262626;
      text-align: center;
    }
  }
}
.data-view {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.card-wrap {
  width: 305px;
  height: 212px;
  background: #fafafa;
  border-radius: 12px;
  margin: 9px;
  margin-bottom: 13px;
  .card-title {
    font-size: 24px;
    color: #878d99;
    line-height: 34px;
    font-weight: 400;
    margin: 32px auto 16px 32px;
  }
  .card-content {
    font-size: 24px;
    color: #666666;
    line-height: 34px;
    margin: 14px auto 32px 32px;
    .card-value-unit {
      font-size: 14px;
    }
  }
  .card-value {
    margin-left: 32px;
    font-size: 36px;
    color: #fd9b21;
    line-height: 50px;
    .card-value-unit {
      font-size: 18px;
    }
  }
}
.data-table {
  margin-top: 28px;
  // border: 1px solid #d9d9d9;
  overflow: hidden;
  border-radius: 3px;
  /deep/ .table-content .table {
    margin: 0;
  }
}
.search_btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
  color: #595959;
}
#card {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
</style>
